<section id="section-report" class="container-fluid">
  <div class="row d-flex justify-content-center" [ngClass]=" editFormat ? '' : 'list-invoice'">
    <app-custom-progress-bar *ngIf="!editFormat" [show]="visibleLoading"
      [heightProgress]="'0.3rem'"></app-custom-progress-bar>
    <div id="container-report" class="col-12 col-lg-12"
      *ngFor="let preinvoicing of preinvoicingPrintModel; trackBy: trackByMovementId"
      [hidden]="!editFormat && visibleLoading">
      <table class="page report table-container" id="preview-preInvoicing-{{preinvoicing.movementId}}"
        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart($event)">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{preinvoicing.movementId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{preinvoicing.movementId}}" [src]="logoEnterprise" alt="" draggable="false">

                  <!--Nit  -->
                  <label id="t-nit-empresa-{{preinvoicing.movementId}}" for="">{{'t-nit-empresa' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="nit-empresa-{{preinvoicing.movementId}}">
                    {{preinvoicing.enterpriseNit}}
                  </p>

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{preinvoicing.movementId}}">
                    {{preinvoicing.enterpriseName}}</p>

                  <!--Sucursal  -->
                  <label id="t-sucursal-{{preinvoicing.movementId}}" for="">{{'t-sucursal' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="codigo-sucursal-{{preinvoicing.movementId}}">
                    {{preinvoicing.branchCode}} </p>
                  <p id="nombre-sucursal-{{preinvoicing.movementId}}">
                    {{preinvoicing.branchName}}</p>

                  <!-- Dirección -->
                  <label id="t-direccion-{{preinvoicing.movementId}}" for="">{{'t-direccion' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="direccion-{{preinvoicing.movementId}}">
                    {{preinvoicing.branchAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{preinvoicing.movementId}}" for="">{{'t-telefono' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="telefono-{{preinvoicing.movementId}}">
                    {{preinvoicing.branchPhone}}</p>


                  <!--titulo-prefactura  -->
                  <p id="nombre-prefactura-{{preinvoicing.movementId}}">MOVIMIENTO ALQUILER NRO.
                    {{preinvoicing.costCenterType}} -
                    {{preinvoicing.consecutive}}</p>

                  <!--Cliente  -->
                  <label id="t-cliente-{{preinvoicing.movementId}}" for="">{{'t-cliente' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="cliente-{{preinvoicing.movementId}}">{{preinvoicing.clientDocumentName1}}</p>

                  <!--Dirección Cliente -->
                  <label id="t-direccion-cliente-{{preinvoicing.movementId}}">{{'t-direccion-cliente' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-cliente-{{preinvoicing.movementId}}"> {{ preinvoicing.clientAddress}}</p>

                  <!--C.Costos  -->
                  <label id="t-centro-costos-{{preinvoicing.movementId}}" for="">{{'t-centro-costos' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="centro-costos-{{preinvoicing.movementId}}" *ngIf="preinvoicing.costCenterId"
                    (click)="onClick()"> {{
                    preinvoicing.costCenterCodeName}}</p>

                  <!--C.Costos Cod. Alterno -->
                  <label id="t-codigo-alterno-{{preinvoicing.movementId}}" for="">{{'t-codigo-alterno' | formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="codigo-alterno-{{preinvoicing.movementId}}" *ngIf="preinvoicing.costCenterId"
                    (click)="onClick()"> {{
                    preinvoicing.costCenterId == null ?
                    '' : preinvoicing.costCenterAlterCode}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-obra-{{preinvoicing.movementId}}">{{'t-direccion-obra' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="direccion-obra-{{preinvoicing.movementId}}">
                    {{preinvoicing.constructionSiteAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-obra-{{preinvoicing.movementId}}">{{'t-telefono-obra' | formatLabelPipe :
                    elementsLabel}}
                  </label>
                  <p id="telefono-obra-{{preinvoicing.movementId}}">
                    {{preinvoicing.constructionSitePhones}}</p>

                  <!--Periodo  -->
                  <label id="t-periodo-{{preinvoicing.movementId}}">{{'t-periodo' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="periodo-{{preinvoicing.movementId}}">{{preinvoicing.dateInitial | date: 'dd/MM/yyyy'}} -
                    {{preinvoicing.dateFinal | date:
                    'dd/MM/yyyy'}}</p>

                  <!-- Zona -->
                  <label id="t-zona-{{preinvoicing.movementId}}">{{'t-zona' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="zona-{{preinvoicing.movementId}}">
                    {{preinvoicing.zoneCodeName}}</p>

                  <!-- Vendedor -->
                  <label id="t-vendedor-{{preinvoicing.movementId}}">{{'t-vendedor' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="vendedor-{{preinvoicing.movementId}}">{{preinvoicing.sellerCodeName}}</p>

                  <p id="vendedor-nombre-{{preinvoicing.movementId}}">{{preinvoicing.sellerName}}</p>


                  <!-- Tipo Negocio -->
                  <label id="t-tipo-negocio-{{preinvoicing.movementId}}">{{'t-tipo-negocio' | formatLabelPipe :
                    elementsLabel}}
                  </label>
                  <p id="tipo-negocio-{{preinvoicing.movementId}}">
                    {{preinvoicing.businessTypeCodeName}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <p-table id="detalle-factura-{{preinvoicing.movementId}}" [value]="preinvoicing.preinvoicingDetails"
                  dataKey="movementDetailId" [columns]="columns" [reorderableColumns]="editFormat"
                  (onColReorder)="onColumnReorder()" [rowGroupMode]="formatModel.group ? 'subheader' : undefined"
                  [groupRowsBy]="formatModel.group ? 'conceptInvoicingId' : undefined"
                  [sortField]="formatModel.group ? 'conceptInvoicingId' : undefined" sortMode="single"
                  styleClass="p-datatable-sm" showGridlines>

                  <ng-template #header pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns; trackBy: trackByColumnField" pReorderableColumn
              [id]="'th-' + idMap[col.field].id + '-' + preinvoicing.movementId" (click)="clickTable($event)">
              {{ col.header }}
            </th>
          </tr>
          </ng-template>
          <ng-template #body pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
            <tr [pReorderableRow]="index">
              <td *ngFor="let col of columns; trackBy: trackByColumnField"
                [id]="'td-' + idMap[col.field].id + '-' + rowData.id" (click)="clickTable($event)">
                {{rowData[col.field] | dynamicFormatPipe: idMap[col.field].type : idMap[col.field].printFormat}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="groupfooter" let-detail>
            <tr *ngIf="formatModel.group" class="row-group-footer">
              <td [attr.colspan]="columns.length">
                <div class="summary-flex-container"
                  *ngIf="(groupDataMap() | groupInfoPipe: preinvoicing.movementId : detail.conceptInvoicingId) as info">

                  <!-- Reteica - Se oculta si no esta activa reteica-->
                  <ng-container *ngIf="reteIca">
                    <p id="foot-group-reteica-{{preinvoicing.movementId}}" (click)="onClick()" class="group-reteica">
                      Rte.ICA:
                      <ng-container
                        *ngIf="labelPrintFormatMap['foot-group-reteica'] as  formatReteIca; else currencyFormatGroupReteIca">
                        {{ info.reteIcaValue | dynamicFormatPipe:'decimal': formatReteIca }}
                      </ng-container>
                      <ng-template #currencyFormatGroupReteIca>
                        {{ info.reteIcaValue | currency }}
                      </ng-template>
                    </p>
                  </ng-container>

                  <!-- Retefuente - Se oculta si no esta activa retefuente-->
                  <ng-container *ngIf="retefuente">
                    <p id="foot-group-retefuente-{{preinvoicing.movementId}}" (click)="onClick()"
                      class="group-retefuente">
                      Rte.Fte:
                      <ng-container
                        *ngIf="labelPrintFormatMap['foot-group-retefuente'] as  formatReteFte; else currencyFormatGroupReteFte">
                        {{ info.reteFuenteValue | dynamicFormatPipe:'decimal': formatReteFte }}
                      </ng-container>
                      <ng-template #currencyFormatGroupReteFte>
                        {{ info.reteFuenteValue | currency }}
                      </ng-template>
                    </p>

                  </ng-container>

                  <!-- Base IVA - Se oculta si la factura es tipo exportación -->
                  <p id="foot-group-baseIva-{{preinvoicing.movementId}}" (click)="onClick()" class="group-baseIva">
                    {{textBaseIva}}
                    <ng-container
                      *ngIf="labelPrintFormatMap['foot-group-baseIva'] as formatBaseIva; else currencyFormatGroupBaseIva">
                      {{ info.valueBaseIva | dynamicFormatPipe:'decimal':formatBaseIva }}
                    </ng-container>
                    <ng-template #currencyFormatGroupBaseIva>
                      {{ info.valueBaseIva | currency }}
                    </ng-template>
                  </p>
                  <p id="foot-group-concept-{{preinvoicing.movementId}}" (click)="onClick()" class="group-concept">
                    {{ info.conceptName }}
                    <ng-container
                      *ngIf="labelPrintFormatMap['foot-group-concept'] as formatConcept; else currencyFormatGroupConcept">
                      {{ info.valueWithDiscount | dynamicFormatPipe:'decimal':formatConcept }}
                    </ng-container>
                    <ng-template #currencyFormatGroupConcept>
                      {{ info.valueWithDiscount | currency }}
                    </ng-template>
                  </p>
                </div>
              </td>
            </tr>
          </ng-template>
          </p-table>
    </div>

    <div id="container-totals" class="d-flex flex-row-reverse pb-2">
      <div id="totals">
        <!-- Subtotal -->
        <div class="row">
          <label id="foot-t-subtotal-{{preinvoicing.movementId}}" for="" class="">{{'foot-t-subtotal' | formatLabelPipe
            :
            elementsLabel}}</label>

          <p id="foot-total-descuento-{{preinvoicing.movementId}}" (click)="onClick()">
            {{preinvoicing.valueDiscount | currency}}</p>

          <p id="foot-subtotal-{{preinvoicing.movementId}}" (click)="onClick()">
            <ng-container *ngIf="labelPrintFormatMap['foot-subtotal'] as  formatSubtotal; else currencyFormatSubtotal">
              {{ preinvoicing.subtotalValue | dynamicFormatPipe:'decimal': formatSubtotal }}
            </ng-container>
            <ng-template #currencyFormatSubtotal>
              {{ preinvoicing.subtotalValue | currency }}
            </ng-template>
          </p>

        </div>

        <!-- Iva -->
        <div class="row">
          <label id="foot-t-valor-iva-{{preinvoicing.movementId}}" for="" class="">{{'foot-t-valor-iva' |
            formatLabelPipe :
            elementsLabel}}</label>

          <p id="foot-espacio-descuento-1-{{preinvoicing.movementId}}" (click)="onClick()"></p>

          <p id="foot-valor-iva-{{preinvoicing.movementId}}" (click)="onClick()">
            <ng-container *ngIf="labelPrintFormatMap['foot-valor-iva'] as  formatIva; else currencyFormatIva">
              {{ preinvoicing.ivaValue | dynamicFormatPipe:'decimal': formatIva }}
            </ng-container>
            <ng-template #currencyFormatIva>
              {{ preinvoicing.ivaValue | currency }}
            </ng-template>
          </p>
        </div>

        <!-- Descuento -->
        <div class="row">
          <label id="foot-t-valor-descuento-{{preinvoicing.movementId}}" for="" class="">{{'foot-t-valor-descuento' |
            formatLabelPipe :
            elementsLabel}}</label>

          <p id="foot-espacio-valor-descuento-{{preinvoicing.movementId}}" (click)="onClick()"></p>

          <p id="foot-valor-descuento-{{preinvoicing.movementId}}" (click)="onClick()">
            <ng-container
              *ngIf="labelPrintFormatMap['foot-valor-descuento'] as  formatDescuento; else currencyFormatDescuento">
              {{ preinvoicing.valueDiscount | dynamicFormatPipe:'decimal': formatDescuento
              }}
            </ng-container>
            <ng-template #currencyFormatDescuento>
              {{ preinvoicing.valueDiscount | currency }}
            </ng-template>
          </p>
        </div>

        <!-- Total -->
        <div class="row">
          <label id="foot-t-total-{{preinvoicing.movementId}}" for="" class="">{{'foot-t-total' | formatLabelPipe :
            elementsLabel}}</label>

          <p id="foot-espacio-descuento-2-{{preinvoicing.movementId}}" (click)="onClick()"></p>

          <p id="foot-total-{{preinvoicing.movementId}}" (click)="onClick()">
            <ng-container *ngIf="labelPrintFormatMap['foot-total'] as  formatTotal; else currencyFormatTotal">
              {{ preinvoicing.totalValue | dynamicFormatPipe:'decimal': formatTotal }}
            </ng-container>
            <ng-template #currencyFormatTotal>
              {{ preinvoicing.totalValue | currency }}
            </ng-template>
          </p>
        </div>

        <!-- ReteIva -->
        <div *ngIf="reteIva" class="row">
          <label id="foot-t-reteIva-{{preinvoicing.movementId}}" for="" class="">{{'foot-t-reteIva' | formatLabelPipe :
            elementsLabel}}</label>

          <p id="foot-espacio-descuento-3-{{preinvoicing.movementId}}" (click)="onClick()"></p>

          <p id="foot-reteIva-{{preinvoicing.movementId}}" (click)="onClick()">
            <ng-container *ngIf="labelPrintFormatMap['foot-reteIva'] as  formatReteIva; else currencyFormatReteIva">
              {{ preinvoicing.reteIvaValue | dynamicFormatPipe:'decimal': formatReteIva
              }}
            </ng-container>
            <ng-template #currencyFormatReteIva>
              {{ preinvoicing.reteIvaValue | currency }}
            </ng-template>
          </p>
        </div>

        <!-- Retefuente -->
        <div *ngIf="retefuente" class="row">
          <label id="foot-t-reteFte-{{preinvoicing.movementId}}" for="" class="">{{'foot-t-reteFte' | formatLabelPipe :
            elementsLabel}}</label>

          <p id="foot-espacio-descuento-4-{{preinvoicing.movementId}}" (click)="onClick()"></p>

          <p id="foot-reteFte-{{preinvoicing.movementId}}" (click)="onClick()">
            <ng-container *ngIf="labelPrintFormatMap['foot-reteFte'] as  formatReteFte; else currencyFormatReteFte">
              {{ preinvoicing.reteFuenteValue |
              dynamicFormatPipe:'decimal': formatReteFte }}
            </ng-container>
            <ng-template #currencyFormatReteFte>
              {{ preinvoicing.reteFuenteValue | currency }}
            </ng-template>
          </p>
        </div>

        <!-- ReteIca -->
        <div *ngIf="reteIca" class="row">
          <label id="foot-t-reteIca-{{preinvoicing.movementId}}" for="" class="">{{'foot-t-reteIca' | formatLabelPipe :
            elementsLabel}}</label>

          <p id="foot-espacio-descuento-5-{{preinvoicing.movementId}}" (click)="onClick()"></p>

          <p id="foot-reteIca-{{preinvoicing.movementId}}" (click)="onClick()">
            <ng-container *ngIf="labelPrintFormatMap['foot-reteIca'] as  formatReteIca; else currencyFormatReteIca">
              {{ preinvoicing.reteIcaValue | dynamicFormatPipe:'decimal': formatReteIca
              }}
            </ng-container>
            <ng-template #currencyFormatReteIca>
              {{ preinvoicing.reteIcaValue | currency }}
            </ng-template>
          </p>
        </div>

        <!-- Total a Pagar -->
        <div class="row">
          <label id="foot-t-valor-pagar-{{preinvoicing.movementId}}" for="" class="">{{'foot-t-valor-pagar' |
            formatLabelPipe :
            elementsLabel}}</label>

          <p id="foot-espacio-descuento-6-{{preinvoicing.movementId}}" (click)="onClick()"></p>

          <p id="foot-valor-pagar-{{preinvoicing.movementId}}" (click)="onClick()">
            <ng-container
              *ngIf="labelPrintFormatMap['foot-valor-pagar'] as  formatValorPagar; else currencyFormatValorPagar">
              {{ preinvoicing.totalValueToPay | dynamicFormatPipe:'decimal': formatValorPagar}}
            </ng-container>
            <ng-template #currencyFormatValorPagar>
              {{ preinvoicing.totalValueToPay | currency }}
            </ng-template>
          </p>
        </div>

      </div>
    </div>
    <div id="foot-{{preinvoicing.movementId}}" [hidden]="!preinvoicing.observationInvoicingCutoff"
      class="foot container-observations">
      <label id="t-observacion-corte-{{preinvoicing.movementId}}"
        *ngIf="preinvoicing.observationInvoicingCutoff">{{'t-observacion-corte' |
        formatLabelPipe : elementsLabel}}</label>
      <p id="observacion-corte-{{preinvoicing.movementId}}" class="lh-1"
        *ngIf="preinvoicing.observationInvoicingCutoff">
        {{preinvoicing.observationInvoicingCutoff}}</p>

    </div>
    </td>
    </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="1">
          <div>
            <p class="information-print">RECUERDE: Tiene 3 días hábiles para devolver ésta prefactura con
              su visto bueno (via
              e-mail). De lo contrario se facturarán los valores aquí relacionados.</p>
            <div class="information-print d-flex">
              <p class="fw-bold pe-4 ">{{version}}</p>
              <label class="fw-bold pe-2">Fecha: </label>
              <p class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
              <label class="fw-bold pe-2">Hora: </label>
              <p class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
              <label class="fw-bold pe-2">Usuario: </label>
              <p class="pe-4"> {{userAuthenticated}}</p>
            </div>
            <div class="d-flex flex-column justify-content-center">
              <div class="d-flex justify-content-center">
                <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                  SAS. Nit.811.022.121-1. www.altos-soft.com</p>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tfoot>
    </table>
  </div>
  </div>
</section>